define([
	"csi/def/ActionFactory",
	"./_StateAction"
], function(ActionFactory,_StateAction) {

	return ActionFactory.declare("MakeCurrent", _StateAction, {
		m_tag: "MakeCurrent",
		
		_hasStateAccess: function(/*csi.def.Context*/ctx, /*Node*/master, /*Node*/revision) {
			// summary: check access based on current state
			return !revision.IsCurrent;
		}
	});
});